import React from 'react';
import styled from 'styled-components';

export type Props = {
  legends?: Legend[];
  isSimilarity?: boolean;
};

export type Legend = {
  text: string;
  color?: string;
};

const PopulationLegend: React.FC<Props> = ({ legends, isSimilarity }) => {
  return (
    <Wrapper isSimilarity={!!isSimilarity}>
      {legends?.map(l => {
        return (
          <PopulationLegendList key={l.text}>
            <LegendColorBox
              //フォーマットが類似エリアかそうでないかで、スタイルを若干変える
              isSimilarity={isSimilarity}
              color={l.color}
            />
            <LegendText>{l.text}</LegendText>
          </PopulationLegendList>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.ul<{ isSimilarity: boolean }>`
  width: 110px;
  height: ${props => (props.isSimilarity ? '160px' : '110px')};
  position: absolute;
  bottom: 20px;
  right: 10px;
  margin: 0;
  padding: 8px;
  border-radius: 2px;
  background: #fff;
  color: #333;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  z-index: 800;
`;

const PopulationLegendList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 11px;
`;

const LegendColorBox = styled.div<{ isSimilarity?: boolean; color?: string }>`
  width: ${props => (props.isSimilarity ? '10px' : '22px')};
  height: ${props => (props.isSimilarity ? '10px' : '22px')};
  background: ${props => (props.color ? props.color : 'white')};
  margin-right: 6;
`;

const LegendText = styled.p`
  max-width: 100px;
`;

export default PopulationLegend;
